export const environment = {
    msalConfig: {
        auth: {
            clientId: 'de6785af-246d-4b4b-b846-7f99357d9f91',
            authority: 'https://login.microsoftonline.com/c990bb7a-51f4-439b-bd36-9c07fb1041c0',
        },
        redirectUri: '/redirect',
        postLogoutRedirectUri: '/logout',
        loginFailedUri: '/login-failed',
    },
    apiConfig: {
        scopes: ['user.read'],
        uri: 'https://graph.microsoft.com/v1.0/me',
    },
    myApiConfig: {
        scopes: ['api://6dbbe6f3-63ea-4a1e-a1ee-b2817e7a2a55/webapp'],
        uri: "https://saapi-docs-dev-1023752604054.us-central1.run.app"
    }
};